<script>
  import { createEventDispatcher } from 'svelte';

  export let text = '';
  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch('select');
  }

  function handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      handleClick();
    }
  }
</script>

<style>
  .dropdown-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
    z-index: 10000;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    background-color: #ddd;
    z-index: 10000;
  }
</style>

<div 
  class="dropdown-item" 
  tabindex="0" 
  role="button" 
  on:click={handleClick} 
  on:keydown={handleKeydown}
>
  {text}
</div>
